<template>
  <v-layout column>

    <h2>VatId settings:</h2>

    <v-layout>
      <v-flex md4>

        <content-field
          label="Increasing percent"
          v-model="settings.increasingPercent"
          @blur="$v.settings.increasingPercent.$touch"
          :error="$v.settings.increasingPercent"
          hint="Enter value between 1-100. This is the amount by which the ticket price increases if the attendee does not enter the vatId"
          persistent-hint
        />

        <content-field
          label="Validation error message"
          v-model="settings.validationErrorMessage"
          @blur="$v.settings.validationErrorMessage.$touch"
          :error="$v.settings.validationErrorMessage"
        />

        <content-field
          label="Invoice with VatId text"
          v-model="settings.invoiceWithVatIdText"
          @blur="$v.settings.invoiceWithVatIdText.$touch"
          :error="$v.settings.invoiceWithVatIdText"
        />

        <content-field
          label="Invoice without VatId text"
          v-model="settings.invoiceWithoutVatIdText"
          @blur="$v.settings.invoiceWithoutVatIdText.$touch"
          :error="$v.settings.invoiceWithoutVatIdText"
        />
      </v-flex>
    </v-layout>



      <v-flex>
        <v-btn
          @click="updateSettings"
          color="success"
          :disabled="!isWriteAvailable"
        >
          Set Settings
        </v-btn>
      </v-flex>

  </v-layout>
</template>

<script>
import { required, numeric, between } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { clone, path } from 'ramda'
import mixins from '@/utils/mixins'

export default {
  name: 'VatIdSettings',
  mixins: [mixins.isWriteAvailable],
  data () {
    return {
      settings: {
        increasingPercent: 0,
        validationErrorMessage: '',
        invoiceWithVatIdText: '',
        invoiceWithoutVatIdText: ''
      },
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'registration:write'
    }
  },
  validations () {
    return {
      settings: {
        increasingPercent: {
          required,
          between: between(0, 100)
        },
        validationErrorMessage: { required },
        invoiceWithVatIdText: { required },
        invoiceWithoutVatIdText: { required }
      }
    }
  },
  computed: {
    ...mapGetters(['getSettings'])
  },
  watch: {
    getSettings: {
      immediate: true,
      handler(newVal) {
        const vatIdSettingsFromGetter = path(
          ['globalSetting', 'vatIdSettings'],
          newVal
        )
        if (vatIdSettingsFromGetter) {
          this.settings = clone(vatIdSettingsFromGetter)
          const increasingPercent = this.settings.increasingPercent * 100
          this.settings.increasingPercent = increasingPercent
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'updateVatIdSettings',
      'fetchGeneralSettings'
    ]),
    async fetchGlobalSettings () {
      try {
        await this.fetchGeneralSettings()
      } catch (err) {
        console.error(err)
      }
    },
    async updateSettings () {
      try {
        this.$v.settings.$touch()
        if (this.$v.settings.$invalid) return
        const payload = clone(this.settings)
        payload.increasingPercent = payload.increasingPercent / 100
        await this.updateVatIdSettings(payload)
      } catch (err) {
        console.error(err)
      }
    }
  },
  mounted() {
    if (!this.getSettings) {
      this.fetchGlobalSettings()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/VatIdSettings.vue